import { Toaster } from "sonner";

export function AppToaster() {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      theme="dark"
      toastOptions={{
        classNames: {
          toast: "border border-white/10 bg-[#132136] text-white",
        },
      }}
    />
  );
}
